import { createContext, useContext } from 'react'
import { type FetchCurrentEnterpriseAccountQuery } from '../../__codegen__/api'

export type CurrentAccountContextValue = {
  account: FetchCurrentEnterpriseAccountQuery['currentEnterpriseAccount']
  refetch: () => void
  /** Whether the user is authenticated (has a valid account) */
  authorized: boolean
  /** Whether the account requires additional setup before accessing the app */
  actionRequired: boolean
}

// @ts-expect-error TS2345 — strictNullChecks. TODO: fix strict null check
export const CurrentAccountContext = createContext<CurrentAccountContextValue>(null)

export const useCurrentAccountContext = () => useContext(CurrentAccountContext)
